

































































































































































import Component from "vue-class-component";
import { FrontModel } from "configurator-base-app/dist/libModules/FrontModel";
import ListingOrizzontale from "./ListingOrizzontale.vue";
import { Vue, Watch } from "vue-property-decorator";
import { FrontalSize } from "configurator-base-app/dist/libModules/FrontalSize";

@Component({ components: { ListingOrizzontale } })
class Frontali extends Vue {
  // #################### INIT ###################

  /**
   * Model filter
   */
  modelSearched: string = "";

  /**
   * Previously selected size
   */
  previousSize: string = "";

  /**
   * Currently selected size
   */
  selectedSize: string = "";

  /**
   * Boolean indicating whether to show the sun model not available dialog
   */
  showSunModelNotAvailable: boolean = false;

  // #################### Methods #############################

  /**
   * Scroll the submenu based on the given direction
   * @param direction
   */
  scrollSubMenu(direction: string) {
    const width = 50;
    const elementToScorll = document.querySelector(
      ".submenu-frame"
    ) as HTMLElement;
    const dir = direction == "left" ? 1 : -1;

    elementToScorll.scrollBy({
      top: 0,
      left: dir * width,
      behavior: "smooth",
    });
  }

  /**
   * Close the dialog regarding the lenses error
   */
  closeDialogErroreLenti() {
    this.$store.commit("openCloseDialogErroreLenti", false);
  }

  /**
   * Reset to the previously selected lenses
   */
  resetPreviousLenses() {
    this.$store.commit(
      "configurator/setOftLensesDxModel",
      this.$store.state.lenteDx
    );
    this.$store.commit(
      "configurator/setOftLensesSxModel",
      this.$store.state.lenteSx
    );
  }

  /**
   * Clear the local lenses
   */
  clearLenses() {
    this.$store.commit("setLenteSx", null);
    this.$store.commit("setLenteDx", null);
  }

  /**
   * Set the currently selected size
   */
  setSizes(val: FrontalSize) {
    this.selectedSize = val.id;
  }

  /**
   * Check whether the current size configuration is valid
   */
  isErrorCaliber() {
    if (
      (this.$store.state.configurator.colore != null ||
        this.$store.state.configurator.coloreAste != null) &&
      this.$store.state.configurator.calibro === "" &&
      this.$store.state.configurator.naso == ""
    ) {
      return true;
    } else {
      return false;
    }
  }

  // #################### Getters/Setters ############################

  /**
   * Get all available front models
   */
  get frames() {
    return this.$store.state.configurator.frontali.items;
  }

  /**
   * Get the currently selected front model
   */
  get frontModel() {
    return this.$store.state.configurator.frontale;
  }

  /**
   * Get the current gauge
   */
  get calibro() {
    const parsed = parseInt(this.$store.state.configurator.calibro);
    return isNaN(parsed) ? 0 : parsed;
  }

  /**
   * Get the current nose fit measurement
   */
  get naso() {
    const parsed = parseInt(this.$store.state.configurator.naso);
    return isNaN(parsed) ? 0 : parsed;
  }

  /**
   * Get all available sizes for front models
   */
  get sizes() {
    return this.$store.state.configurator.frontali.itemsSizes;
  }

  /**
   * Get the list of available front models, filtered
   */
  get filteredFrames(): Array<FrontModel> {
    return this.frames.filter((frame: FrontModel) => {
      return (
        frame.U_TIPO_VSP == this.glassType &&
        frame.U_THE_MODELLO.indexOf(this.modelSearched) > -1
      );
    });
  }

  /**
   * Get the list of available sizes, filtered based on the current front model
   */
  public get availableSizes(): Array<FrontalSize> {
    return this.sizes.filter((size: FrontalSize) => {
      return size.ItemCode == this.$store.state.configurator.frontale.ItemCode;
    });
  }

  /**
   * Currently selected type of glasses: eyeglasses or sunglasses
   */
  public get glassType(): string {
    return this.$store.state.configurator.glassType;
  }
  public set glassType(t: string) {
    this.$store.commit("configurator/setLensesType", t, { root: true });

    // If the selected model is sun, check whether the sun version is actually available
    if (t == "S") {
      const filtered = this.frames.filter((i: FrontModel) => {
        return i.U_THE_CUSMODEL == "C" && i.U_TIPO_VSP == "S";
      });
      // If the corresponding sun model is not found, show an error to the user and bring him back to sight models
      if (
        filtered.find((f: FrontModel) => {
          return (
            f.U_THE_MODELLO ==
            this.frontModel.U_THE_MODELLO.replaceAll("C", "SC")
          );
        }) == undefined
      ) {
        this.showSunModelNotAvailable = true;
        return;
      }

      this.$store.commit("setLenteDx", null);
      this.$store.commit("setLenteSx", null);
      this.$store.commit("resetLentiVista");
      this.$store.commit("configurator/lenti/resetCfgLenteVistaDx");
      this.$store.commit("configurator/lenti/resetCfgLenteVistaSx");
      this.$store.commit("resetRowNotes");
    }
  }

  /**
   * Check whether there are errors in the front model
   */
  get checkErrorsFrontale(): any {
    return this.$store.getters["configurator/frontali/checkErrors"];
  }

  // #################### Watchers ###########################

  @Watch("selectedSize")
  sizeChanged(newV: string): void {
    let s = this.availableSizes.filter((s: FrontalSize) => {
      return s.id == newV;
    });
    if (s.length > 0) {
      const foundSize = this.sizes.find(
        (el: FrontalSize) =>
          el.U_THE_MODELLO == this.frontModel.U_THE_MODELLO &&
          el.size_eye == this.calibro.toFixed(2) &&
          el.size_bridge == this.naso.toFixed(2)
      );
      this.previousSize = foundSize == undefined ? null : foundSize.id;
      this.$store.commit("configurator/setSize", s[0]);
    } else {
      this.$store.commit("configurator/setSize", {
        size_eye: "",
        size_bridge: "",
      });
    }
  }

  @Watch("calibro")
  calibroChanged(newV: string): void {
    if (newV == "") {
      this.selectedSize = "";
    }
  }

  @Watch("glassType")
  glassTypeChanged(newVal: string): void {
    this.$store.commit("configurator/setSunLensesModel", null);

    const m: Array<FrontModel> = this.frames.filter((i: FrontModel) => {
      return (
        i.U_THE_MODELLO.replace("SC", "").replace("C", "") ==
          this.frontModel.U_THE_MODELLO.replace("SC", "").replace("C", "") &&
        i.U_TIPO_VSP == newVal
      );
    });

    if (m.length > 0) {
      this.$store.commit("configurator/setFrontal", m[0]);
    }

    if (this.calibro && this.naso) {
      const s: Array<FrontalSize> = this.availableSizes.filter(
        (is: FrontalSize) => {
          return (
            is.ItemCode == m[0].ItemCode &&
            parseInt(is.size_eye) == this.calibro &&
            parseInt(is.size_bridge) == this.naso
          );
        }
      );

      if (s.length > 0) {
        this.$store.commit("configurator/setSize", s[0]);
      }
    }
  }
}
export default Frontali;
